import Modal from "../../../global/components/Modal/Modal.vue";
import PuxButton from "../../../global/components/PuxButton/PuxButton.vue";
import PuxTranslate from "../../../global/components/PuxTranslate/PuxTranslate.vue";

import HttpMixin from "../../../global/mixins/HttpMixin";
import NotificationMixin from "../../../global/mixins/NotificationMixin";
import {
  FilterSpacedMixin,
} from "../../../global/mixins/FiltersMixin";

import {
  cloneDeep,
} from "lodash-es";

// @vue/component
export default {
  name: "SitzungsantraegeModalEntscheidungAnmerkung",
  components: {
    Modal,
    PuxButton,
    PuxTranslate,
  },
  mixins: [
    FilterSpacedMixin,
    HttpMixin,
    NotificationMixin,
  ],
  props: {
    baseSaveUrl: {
      type: String,
      default: undefined,
    },
    sitzungsantrag: {
      type: Object,
      default: () => ({}),
    },
    close: {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      model: {
        sla_entscheidung_anmerkung: undefined,
      },
      options: {
        showCloseButton: true,
        required: true,
        list: [
          {
            id: "sla_entscheidung_anmerkung",
            type: "richtext",
            required: true,
            label: "_LBL_MODAL_AUFLAGE_ANMERKUNG_",
            view: "v-alt",
          },
        ],
      },
      status: {
        loading: undefined,
      },
      errors: undefined,
      errorsClone: undefined,
    };
  },
  created() {
    this.initModel();
  },
  methods: {
    initModel() {
      this.model.sla_entscheidung_anmerkung = this.sitzungsantrag.sla_entscheidung_anmerkung;
    },

    save() {
      this.status.loading = true;
      const data = cloneDeep(this.model);
      this.putHttp({
        url: `${ this.baseSaveUrl }${ this.sitzungsantrag.pk }/setze_entscheidung_anmerkung/`,
        data
      }).then(
        response => {
          this.addNotification({ text: "_MSG_SITZUNGSANTRAEGE_MODAL_ENTSCHEIDUNG_ANMERKUNG_SAVE_SUCCESS_" });
          const NEW_SITZUNGSANTRAG = cloneDeep(this.sitzungsantrag);
          NEW_SITZUNGSANTRAG.sla_entscheidung_anmerkung = response.sla_entscheidung_anmerkung;
          this.close({ NEW_SITZUNGSANTRAG });
        },
        error => {
          this.errors = error.data;
          this.errorsClone = error.data;
        }
      ).then(
        () => this.status.loading = false
      );
    },
  },
};
